/** CSS color parsing — hex, rgb(a), hsl(a), transparent, and common named colors. */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var NAMED = {
    transparent: 'rgba(0,0,0,0)',
    black: '#000000',
    white: '#ffffff',
    red: '#ff0000',
    green: '#008000',
    blue: '#0000ff',
    yellow: '#ffff00',
    cyan: '#00ffff',
    aqua: '#00ffff',
    magenta: '#ff00ff',
    fuchsia: '#ff00ff',
    orange: '#ffa500',
    purple: '#800080',
    pink: '#ffc0cb',
    gray: '#808080',
    grey: '#808080',
    silver: '#c0c0c0',
    maroon: '#800000',
    navy: '#000080',
    olive: '#808000',
    teal: '#008080',
    lime: '#00ff00',
    indigo: '#4b0082',
    violet: '#ee82ee',
    coral: '#ff7f50',
    gold: '#ffd700',
    tomato: '#ff6347',
    crimson: '#dc143c',
    slategray: '#708090',
    slategrey: '#708090',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    steelblue: '#4682b4',
    royalblue: '#4169e1',
    dodgerblue: '#1e90ff',
    deepskyblue: '#00bfff',
    skyblue: '#87ceeb',
    lightblue: '#add8e6',
    lightskyblue: '#87cefa',
    mediumblue: '#0000cd',
    darkblue: '#00008b',
    midnightblue: '#191970',
    forestgreen: '#228b22',
    seagreen: '#2e8b57',
    mediumseagreen: '#3cb371',
    lightgreen: '#90ee90',
    darkgreen: '#006400',
    springgreen: '#00ff7f',
    chartreuse: '#7fff00',
    darkorange: '#ff8c00',
    orangered: '#ff4500',
    hotpink: '#ff69b4',
    deeppink: '#ff1493',
    lightpink: '#ffb6c1',
    brown: '#a52a2a',
    chocolate: '#d2691e',
    sienna: '#a0522d',
    peru: '#cd853f',
    wheat: '#f5deb3',
    tan: '#d2b48c',
    beige: '#f5f5dc',
    ivory: '#fffff0',
    snow: '#fffafa',
    ghostwhite: '#f8f8ff',
    whitesmoke: '#f5f5f5',
    gainsboro: '#dcdcdc',
    lightgray: '#d3d3d3',
    lightgrey: '#d3d3d3',
    darkgray: '#a9a9a9',
    darkgrey: '#a9a9a9',
    dimgray: '#696969',
    dimgrey: '#696969',
};
function clamp01(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
}
function clamp255(n) {
    return n < 0 ? 0 : n > 255 ? 255 : n;
}
function parseHexByte(pair) {
    return parseInt(pair, 16);
}
function parseHexColor(hex) {
    var raw = hex.slice(1);
    if (![3, 4, 6, 8].includes(raw.length))
        return null;
    if (!__spreadArray([], __read(raw), false).every(function (c) { return /[0-9a-f]/i.test(c); }))
        return null;
    var expand = function (s) { return s.split('').map(function (c) { return c + c; }).join(''); };
    var full = raw.length <= 4 ? expand(raw) : raw;
    var r = parseHexByte(full.slice(0, 2));
    var g = parseHexByte(full.slice(2, 4));
    var b = parseHexByte(full.slice(4, 6));
    var a = full.length === 8 ? parseHexByte(full.slice(6, 8)) / 255 : 1;
    if ([r, g, b, a].some(function (n) { return Number.isNaN(n); }))
        return null;
    return { r: r, g: g, b: b, a: a };
}
function parseChannel(raw, kind) {
    var s = raw.trim();
    if (!s || s === 'none')
        return null;
    if (s.endsWith('%')) {
        var pct = parseFloat(s.slice(0, -1));
        if (Number.isNaN(pct))
            return null;
        return kind === 'rgb' ? (pct / 100) * 255 : pct / 100;
    }
    var n = parseFloat(s);
    return Number.isNaN(n) ? null : n;
}
function parseAlpha(raw, fallback) {
    if (fallback === void 0) { fallback = 1; }
    if (raw == null || raw === '')
        return fallback;
    var s = raw.trim();
    if (s.endsWith('%')) {
        var pct = parseFloat(s.slice(0, -1));
        return Number.isNaN(pct) ? fallback : clamp01(pct / 100);
    }
    var n = parseFloat(s);
    return Number.isNaN(n) ? fallback : clamp01(n);
}
/** Split `rgb(...)` / `hsl(...)` args — comma or space separated, optional `/ alpha`. */
function splitCssArgs(inner) {
    var _a;
    var slash = inner.split('/');
    var main = slash[0].trim();
    var alpha = (_a = slash[1]) === null || _a === void 0 ? void 0 : _a.trim();
    var parts = main.includes(',')
        ? main.split(',').map(function (p) { return p.trim(); }).filter(Boolean)
        : main.split(/\s+/).filter(Boolean);
    if (alpha)
        parts.push(alpha);
    return parts;
}
function hslToRgb(h, s, l) {
    var _a, _b, _c, _d, _e, _f;
    var hue = ((h % 360) + 360) % 360;
    var sat = clamp01(s);
    var light = clamp01(l);
    var c = (1 - Math.abs(2 * light - 1)) * sat;
    var x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
    var m = light - c / 2;
    var rp = 0;
    var gp = 0;
    var bp = 0;
    if (hue < 60)
        _a = __read([c, x, 0], 3), rp = _a[0], gp = _a[1], bp = _a[2];
    else if (hue < 120)
        _b = __read([x, c, 0], 3), rp = _b[0], gp = _b[1], bp = _b[2];
    else if (hue < 180)
        _c = __read([0, c, x], 3), rp = _c[0], gp = _c[1], bp = _c[2];
    else if (hue < 240)
        _d = __read([0, x, c], 3), rp = _d[0], gp = _d[1], bp = _d[2];
    else if (hue < 300)
        _e = __read([x, 0, c], 3), rp = _e[0], gp = _e[1], bp = _e[2];
    else
        _f = __read([c, 0, x], 3), rp = _f[0], gp = _f[1], bp = _f[2];
    return [
        Math.round(clamp255((rp + m) * 255)),
        Math.round(clamp255((gp + m) * 255)),
        Math.round(clamp255((bp + m) * 255)),
    ];
}
function parseFunctional(color) {
    var rgbMatch = color.match(/^rgba?\(\s*([\s\S]+)\)$/i);
    if (rgbMatch) {
        var parts = splitCssArgs(rgbMatch[1]);
        if (parts.length < 3)
            return null;
        var r = parseChannel(parts[0], 'rgb');
        var g = parseChannel(parts[1], 'rgb');
        var b = parseChannel(parts[2], 'rgb');
        if (r == null || g == null || b == null)
            return null;
        return {
            r: clamp255(r),
            g: clamp255(g),
            b: clamp255(b),
            a: parseAlpha(parts[3]),
        };
    }
    var hslMatch = color.match(/^hsla?\(\s*([\s\S]+)\)$/i);
    if (hslMatch) {
        var parts = splitCssArgs(hslMatch[1]);
        if (parts.length < 3)
            return null;
        var h = parseFloat(parts[0]);
        var s = parseChannel(parts[1], 'hsl');
        var l = parseChannel(parts[2], 'hsl');
        if (Number.isNaN(h) || s == null || l == null)
            return null;
        var _a = __read(hslToRgb(h, s, l), 3), r = _a[0], g = _a[1], b = _a[2];
        return { r: r, g: g, b: b, a: parseAlpha(parts[3]) };
    }
    return null;
}
/**
 * Parse a CSS color string into RGBA components.
 * Returns `null` when the format is not recognized.
 */
export function tryParseColor(color) {
    if (!color)
        return null;
    var trimmed = color.trim();
    if (!trimmed)
        return null;
    var lower = trimmed.toLowerCase();
    if (lower === 'transparent')
        return { r: 0, g: 0, b: 0, a: 0 };
    if (trimmed.startsWith('#'))
        return parseHexColor(trimmed);
    var functional = parseFunctional(trimmed);
    if (functional)
        return functional;
    var named = NAMED[lower.replace(/\s+/g, '')];
    if (named)
        return tryParseColor(named);
    return null;
}
/** Parse color; unknown values fall back to opaque black (legacy behavior). */
export function parseColor(color) {
    var _a;
    return (_a = tryParseColor(color)) !== null && _a !== void 0 ? _a : { r: 0, g: 0, b: 0, a: 1 };
}
/** Re-encode with a new alpha. Returns `null` if `color` cannot be parsed. */
export function colorWithAlpha(color, alpha) {
    var c = tryParseColor(color);
    if (!c)
        return null;
    var a = clamp01(alpha);
    return "rgba(".concat(Math.round(c.r), ", ").concat(Math.round(c.g), ", ").concat(Math.round(c.b), ", ").concat(a, ")");
}
/** Linear RGB mix; falls back to `to` if either side cannot be parsed. */
export function mixColors(from, to, t) {
    var a = tryParseColor(from);
    var b = tryParseColor(to);
    if (!a || !b)
        return to;
    var u = clamp01(t);
    var r = Math.round(a.r + (b.r - a.r) * u);
    var g = Math.round(a.g + (b.g - a.g) * u);
    var bl = Math.round(a.b + (b.b - a.b) * u);
    var alpha = a.a + (b.a - a.a) * u;
    return alpha < 1 ? "rgba(".concat(r, ",").concat(g, ",").concat(bl, ",").concat(alpha, ")") : "rgb(".concat(r, ",").concat(g, ",").concat(bl, ")");
}
export function interpolateColor(from, to, t) {
    return mixColors(from, to, t);
}
/** True when the string looks like a concrete CSS color (not a semantic token). */
export function isCssColorString(color) {
    if (!color)
        return false;
    var t = color.trim().toLowerCase();
    if (t.startsWith('#') || t.startsWith('rgb') || t.startsWith('hsl'))
        return true;
    if (t === 'transparent')
        return true;
    return t.replace(/\s+/g, '') in NAMED;
}
